import React from 'react';
import Main from './container/main'
import './App.css';
import { useMemo, useState } from 'react';
import { LoggedInContext } from './Login-Context'

function App() {
  const [loggedInUser, setLoggedInUser] = useState<any>({});

  const value = useMemo(
    () => ({ loggedInUser, setLoggedInUser }),
    [loggedInUser]
  );
  return (
    <div className="App">
      <LoggedInContext.Provider value={value}>
        <Main />
      </LoggedInContext.Provider>
    </div>
  );
}

export default App;
